<script setup lang="ts">
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import { ShowcaseLayout } from '@Shared';
import useCompanyImageBaseUrl from '@Src/use/useCompanyImageBaseUrl';
import ShowcaseImage from '@Components/ShowcaseImage.vue';

const companyStore = useCompanyStore();
const locationStore = useLocationStore();
const companyImageBaseUrl = useCompanyImageBaseUrl();

</script>

<template>
    <showcase-layout
        title="Progress saved"
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        show-powered-by>

        <template #mobileAccent>
            <div class="esignature-finish-later-candy">
                <img
                    class="esignature-finish-later-candy__image"
                    :src="'/images/esignature/secure-signing.svg'"
                />
            </div>
        </template>

        <template #branded>
            <showcase-image />
        </template>

        <app-form-content-layout>
            <div class="success-content">
                <p>
                    Your document has been saved. You can return anytime using the link in your email and SMS.
                    <br />
                    <br />
                    When you're ready, you can continue right where you left off.
                </p>
            </div>
        </app-form-content-layout>
    </showcase-layout>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.esignature-finish-later-candy {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    &__image {
        max-width: 11.6875rem;
        max-height: 11rem;

        @include desktop {
            width: 25rem;
            max-width: none;
            max-height: 21.6875rem;
        }
    }
}
</style>

